// extracted by mini-css-extract-plugin
export default {"masks":"EditorTourHighlightedAreas_masks__Y+s9O"};